import {Injectable} from '@angular/core';
import * as moment from 'moment';
import {StoreInvoice} from '../shared/model/StoreInvoice';
import {Invoice} from '../shared/model/Invoice';
import {InvoiceStore} from '../shared/model/InvoiceStore';
import {GLGuide} from '../shared/model/GLGuide';
import {JwtService} from 'mclane-webauth-lib';
import {HomeOffice} from '@model/HomeOffice';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {ToastrService} from "ngx-toastr";


@Injectable({
  providedIn: 'root'
})
export class UserService {
  readonly USERNAME = '/user/name';
  selectedParents: Array<string> = new Array<string>();
  selectedInvoiceParents: Array<string> = new Array<string>();
  selectedStoresMap: Map<string, StoreInvoice> = new Map<string, StoreInvoice>();
  selectedInvoiceStoresMap: Map<string, InvoiceStore> = new Map<string, InvoiceStore>();
  selectedStores: Array<string> = new Array<string>();
  selectedStatementStores: Array<string> = new Array<string>();
  selectedStatementInvoices: Array<string> = new Array<string>();
  selectedInvInvoices: Array<string> = new Array<string>();
  selectedInvoicesMap: Map<string, StoreInvoice> = new Map<string, StoreInvoice>();
  selectedInvoicesMapInvoice: Map<string, Invoice> = new Map<string, Invoice>();
  glGuides: Array<GLGuide> = new Array<GLGuide>();
  selectedGLGuides: string[] = new Array<string>();
  selectedGLGuidesMap: Map<string, GLGuide> = new Map<string, GLGuide>();
  selectedGLGuideIds: Array<number> = new Array<number>();
  selectedGLCodes: Array<string> = new Array<string>();
  fromRange: string;
  toRange: string;
  backClicked: boolean = false;
  selectedInvoiceStores: Array<string> = new Array<string>();
  private selectedRequestType: string = 'D';
  private selectedRequestTypeInvoice: string = 'I';
  private selectedInvReqType: string = 'I';
  private selectedDateType: string = 'ID';
  private downloaded: boolean = false;
  private selectedStartDate: Date = moment(new Date(1900, 1, 1)).toDate();
  private selectedEndDate: Date = moment().toDate();
  private selectedStartDateInvoice: Date;
  private selectedEndDateInvoice: Date;
  private selectedInvType: string = 'I';
  private selectedInvTypeInvoice: string = 'ID';
  private dateRangeChk: boolean;
  private dateRangeChkInvoice: boolean;
  private roles: string[];
  public selectedHomeOffice: HomeOffice;
  storesOriginal: Array<InvoiceStore> = new Array<InvoiceStore>();
  private bulkSelect: boolean = false;
  private parentCustomerNumbers: string[] = [];


  private readonly userName: string = '';
  private _ogStartDate: Date;


  constructor(private jwt: JwtService,
              public localStorage: LocalStorageIndexedService,
              private _toaster: ToastrService) {

    this.userName = this.jwt.preferred_username;
    this.roles = this.jwt.roles;
  }


  getUserName(): string {
    return this.userName;
  }

  getUserRoles(): string[] {
    return this.roles;
  }

  setSelectedRequestType(selectedRequestType: string) {
    if (selectedRequestType) {
      this.selectedRequestType = selectedRequestType;
    }
  }

  getSelectedRequestType(): string {
    return this.selectedRequestType;
  }

  setSelectedDateType(selectedDateType: string) {
    if (selectedDateType) {
      this.selectedDateType = selectedDateType;
    }
  }

  getSelectedDateType() {
    return this.selectedDateType;
  }

  setSelectedEndDate(selectedEndDate: Date) {
    if (selectedEndDate) {
      this.selectedEndDate = selectedEndDate;
    }
  }

  getSelectedEndDate(): Date {
    return this.selectedEndDate;
  }

  setSelectedStartDate(selectedStartDate: Date) {
    if (selectedStartDate) {
      this.selectedStartDate = selectedStartDate;
    }
  }

  getSelectedStartDate(): Date {
    return this.selectedStartDate;
  }

  setOriginalStartDate(ogStartDate) {
    if(ogStartDate) {
      this._ogStartDate = ogStartDate.asOfDate;
    }
  }

  getOriginalStartDate() {
    return this._ogStartDate;
  }

  setFromRange(fromRange: string) {
    if (fromRange) {
      this.fromRange = fromRange;
    }
  }

  setToRange(toRange: string) {
    if (toRange) {
      this.toRange = toRange;
    }
  }

  getFromRange(): string {
    return this.fromRange;
  }

  getToRange(): string {
    return this.toRange;
  }

  setSelectedInvType(selectedInvType: string) {
    if (selectedInvType) {
      this.selectedInvType = selectedInvType;
    }
  }

  getSelectedInvType(): string {
    return this.selectedInvType;
  }

  //grab request type from invoice select screen options: 'I', 'O' and 'D'
  setSelectedRequestTypeInvoice(selectedRequestTypeInvoice: string) {
    if (selectedRequestTypeInvoice) {
      this.selectedRequestTypeInvoice = selectedRequestTypeInvoice;
    }
  }

  //set request type from invoice select screen options: 'I', 'O' and 'D'
  getSelectedRequestTypeInvoice(): string {
    return this.selectedRequestTypeInvoice;
  }

  setSelectedEndDateInvoice(selectedEndDateInvoice: Date) {
    if (selectedEndDateInvoice) {
      this.selectedEndDateInvoice = selectedEndDateInvoice;
    }
  }

  getSelectedEndDateInvoice(): Date {
    return this.selectedEndDateInvoice;
  }

  setSelectedStartDateInvoice(selectedStartDateInvoice: Date) {
    if (selectedStartDateInvoice) {
      this.selectedStartDateInvoice = selectedStartDateInvoice;
    }
  }

  getSelectedStartDateInvoice(): Date {
    return this.selectedStartDateInvoice;
  }

  setSelectedInvTypeInvoice(selectedInvTypeInvoice: string) {
    if (selectedInvTypeInvoice) {
      this.selectedInvTypeInvoice = selectedInvTypeInvoice;
    }
  }

  getSelectedInvTypeInvoice(): string {
    return this.selectedInvTypeInvoice;
  }

  setDateRangeChkInvoice(dateRangeChkInvoice: boolean) {
    this.dateRangeChkInvoice = dateRangeChkInvoice;
  }

  getDateRangeChkInvoice(): boolean {
    return this.dateRangeChkInvoice;
  }

  setDateRangeChk(dateRangeChk: boolean) {
    this.dateRangeChk = dateRangeChk;
  }

  getDateRangeChk(): boolean {
    return this.dateRangeChk;
  }

  setSelectedParents(selectedParents: Array<string>) {
    this.selectedParents = selectedParents;
  }

  getSelectedParents(): Array<string> {
    return this.selectedParents;
  }

  setSelectedInvoiceParents(selectedParents: Array<string>) {
    this.selectedInvoiceParents = selectedParents;
  }

  getSelectedInvoiceParents(): Array<string> {
    return this.selectedInvoiceParents;
  }

  setSelectedStoresMap(selectedStoresMap: Map<string, StoreInvoice>) {
    this.selectedStoresMap = new Map<string, StoreInvoice>();
    this.selectedStoresMap = selectedStoresMap;
  }

  setSelectedInvoiceStoresMap(selectedInvoiceStoresMap: Map<string, InvoiceStore>) {
    this.selectedInvoiceStoresMap = new Map<string, InvoiceStore>();
    this.selectedInvoiceStoresMap = selectedInvoiceStoresMap;
  }

  getSelectedStoresMap() {
    return this.selectedStoresMap;
  }

  getSelectedInvoiceStoresMap() {
    return this.selectedInvoiceStoresMap;
  }

  getSelectedInvoicesMapInvoice() {
    return this.selectedInvoicesMapInvoice;
  }

  getSelectedStores(): Array<string> {
    this.selectedStores = new Array<string>();
    this.selectedStoresMap.forEach((store, shipToSiteNumber) => {
      this.selectedStores.push(shipToSiteNumber);
    });
    return this.selectedStores;
  }

  setSelectedInvoicesMap(selectedInvoicesMap: Map<string, StoreInvoice>) {
    this.selectedInvoicesMap = new Map<string, StoreInvoice>();
    this.selectedInvoicesMap = selectedInvoicesMap;
  }

  setSelectedInvoicesMapInvoice(selectedInvoicesMapInvoice: Map<string, Invoice>) {
    this.selectedInvoicesMapInvoice = new Map<string, Invoice>();
    this.selectedInvoicesMapInvoice = selectedInvoicesMapInvoice;
  }

  setBackClicked(backClicked: boolean) {
    this.backClicked = backClicked;
  }

  getBackClicked(): boolean {
    return this.backClicked;
  }

  setSelectedStatementStores(selectedIS: string[]) {
    this.selectedStatementStores = selectedIS;
  }

  getSelectedStatementStores(): string[] {
    return this.selectedStatementStores;
  }

  setSelectedStatementInvoices(selectedIS: string[]) {
    this.selectedStatementInvoices = selectedIS;
  }

  getSelectedStatementInvoices(): string[] {
    return this.selectedStatementInvoices;
  }

  setSelectedInvoiceStores(selectedIS: string[]) {
    this.selectedInvoiceStores = selectedIS;
  }

  getSelectedInvoiceStores(): string[] {
    return this.selectedInvoiceStores;
  }

  setSelectedInvoices(selectedInvoices: string[]) {
    this.selectedInvInvoices = selectedInvoices;
  }

  getSelectedInvoices(): string[] {
    return this.selectedInvInvoices;
  }

  setSelectedInvReqType(selectedRequestType: string) {
    if (selectedRequestType) {
      this.selectedInvReqType = selectedRequestType;
    }
  }

  getSelectedInvReqType(): string {
    return this.selectedInvReqType;
  }

  setDownloaded(download: boolean) {
    this.downloaded = download;
  }

  getDownloaded(): boolean {
    return this.downloaded;
  }


  setGLGuides(selectedGLGuides: Array<GLGuide>) {
    this.glGuides = selectedGLGuides;
  }

  getGLGuides(): Array<GLGuide> {
    return this.glGuides;
  }


  setSelectedGLCodes(selectedCodes: string[]) {
    this.selectedGLCodes = selectedCodes;
  }


  public userHomeOffice(homeOffice: HomeOffice) {
    this.selectedHomeOffice = homeOffice;
    this.localStorage.setToSession(AppEnums.HOME_OFFICE, this.selectedHomeOffice);
  }

  public showNotification(content: string, timeout: number) {
    this._toaster.info(content, '', {timeOut: timeout});
  }

  public showError(content: string, timeout: number) {
    this._toaster.error(content, '', {timeOut: timeout});
  }

  setStoresOriginal(stores: Array<InvoiceStore>) {
    this.storesOriginal = stores;
  }

  getStoresOriginal(): Array<InvoiceStore> {
    return this.storesOriginal;
  }

  setBulkSelect(bulkSelect: boolean) {
    this.bulkSelect = bulkSelect;
  }

  getBulkSelect(): boolean {
    return this.bulkSelect;
  }
}
